import { cache } from 'react';

import { QueryClient, useQuery } from '@tanstack/react-query';

import { ESHOP_QUERY_KEY } from '@telialt/core-eshop/src/model';
import { API } from '@telialt/core-eshop/src/store/constants';
import { ProductMetadata } from '@telialt/models/src/EshopModel';
import { axiosForHybris } from '@telialt/utils/src/axios/axiosForHybris';
import { withParams } from '@telialt/utils/src/helpers';
import { getSiteName, TeliaSegment, useSegment } from '@telialt/utils/src/segment';

export const apiGetProductMetadata = cache(async (productUrl: string, segment: TeliaSegment) => {
    const siteName = getSiteName(segment);

    const response = await axiosForHybris.get<ProductMetadata>(
        withParams(API.URL_PRODUCT_METADATA, { siteName, productUrl }),
    );

    return response.data;
});

export const useProductMetadata = (productUrl?: string) => {
    const segment = useSegment();

    return useQuery({
        queryKey: [ESHOP_QUERY_KEY.PRODUCT_METADATA, productUrl, segment],
        queryFn: () => apiGetProductMetadata(productUrl, segment),
        enabled: !!productUrl,
    });
};

export const prefetchProductMetadata = (queryClient: QueryClient, productUrl: string, segment: TeliaSegment) => {
    return queryClient.prefetchQuery({
        queryKey: [ESHOP_QUERY_KEY.PRODUCT_METADATA, productUrl, segment],
        queryFn: async () => {
            return apiGetProductMetadata(productUrl, segment);
        },
    });
};
